/**
 * A formula to retrieve the control height.
 * Use this as the value of any CSS property that
 * accepts a pixel size.
 */
export const heightNumber = "(var(--base-height-multiplier) + var(--density)) * var(--design-unit)";
